export enum AppLinks {
  WEBSITE = "https://www.dome-care.com/",
  EMAIL = "mailto:info@dome-care.com",
  PHONE = "tel:+971 507655005",
}
//mailto:info@dome-care.com

export const gridColsMap = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  8: "grid-cols-8",
  7: "grid-cols-7",
  9: "grid-cols-9",
  10: "grid-cols-10",
} as const;
